<template>
  <div id="app">
    <router-view/>
    <notifications group="foo" />
  </div>
</template>

<script>
export default {

  beforeDestroy() {
      if (document.querySelector("meta[name=google-signin-client_id]")) {

          document.querySelector("meta[name=google-signin-client_id]").remove()
      }
  },
  mounted() {
      const meta_element = document.createElement('meta');
      meta_element.setAttribute('name', 'google-signin-client_id');
      meta_element.setAttribute('content', process.env.VUE_APP_GOOGLE_CLIENTID);
      document.head.appendChild(meta_element);
    
  },
}
</script>


<style>


@import url('https://fonts.googleapis.com/css?family=Dosis:200,300,400,500,600,700,800');
@import url('https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700');

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /* font-family: 'Source Sans Pro', sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #043B56;
  padding: 0;
  margin: 0;
  font-weight: 400 !important;
}
body, html {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
  background: rgb(240, 241, 246) !important;
  font-size: 16px;
  line-height: 1.7em;
  font-weight: 400;

  /* color: #6F8BA4; */
}

/*

a.router-link-exact-active {
  color: #42b983;
} */

  @import './assets/css/custom.css';
  @import './assets/css/bootstrap.min.css';
  @import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css';
</style>
